import chatsService from "../services/chats.service";
import {
  CHAT_SINGLE_USER_LIST,
  CHAT_SINGLE_USER_LIST_LOADER,
  CHAT_USER_LIST,
  CHAT_USER_LIST_LOADER,
} from "./type";

export const userConversationList = (id, search, page, limit) => (dispatch) => {
  dispatch({ type: CHAT_USER_LIST_LOADER, payload: true });
  return chatsService
    .chatUserListAction(id, search, page, limit)
    .then((resp) => {
      if (resp.status === 200) {
        dispatch({ type: CHAT_USER_LIST, payload: resp.data });
      } else {
        dispatch({ type: CHAT_USER_LIST_LOADER, payload: null });
      }
      return resp;
    });
};

export const userSingleConversationList = (id) => (dispatch) => {
  dispatch({ type: CHAT_SINGLE_USER_LIST_LOADER, payload: true });
  return chatsService.singleUserListAction(id).then((resp) => {
    if (resp.status === 200) {
      dispatch({ type: CHAT_SINGLE_USER_LIST, payload: resp.data });
    } else {
      dispatch({ type: CHAT_SINGLE_USER_LIST_LOADER, payload: null });
    }
    return resp;
  });
};

export const resetUnreadCount = (conversationId, userId) => (dispatch) => {
  return chatsService
    .resetUnreadCountAction(conversationId, userId)
    .then((resp) => {
      return resp;
    })
    .catch((err) => {
      console.log("Reset unread error", err);
    });
}
